import { jsx as L } from "react/jsx-runtime";
import { useMemo as x, useCallback as P, useLayoutEffect as v } from "react";
import { useConfig as h } from "@perxis-auto/credit-sdk";
import { APP_EVENTS_CHANNEL as C } from "../../../shared/config/events.js";
import { LanguageEnum as N, CurrencyEnum as _, AppContext as b } from "../../../shared/lib/app/context/appContext.js";
import { withCreditProvider as j } from "../../../shared/lib/app/hoc/withCreditProvider.js";
const k = ({
  apiRoot: o,
  clientId: e,
  language: m = N.Ru,
  currency: f = _.RUB,
  displayProgramName: p = !0,
  initialValues: r,
  creditParamsFormatter: n,
  eventsHandler: u,
  children: c
}) => {
  const { actions: t } = h(), i = x(
    () => ({
      apiRoot: o,
      clientId: e,
      currency: f,
      language: m,
      displayProgramName: p,
      initialValues: r,
      creditParamsFormatter: n
    }),
    [o, e, f, m, p, r, n]
  ), s = P(
    (E) => {
      if (!u)
        return;
      const { type: d } = E.detail, A = E.detail;
      u(d, A);
    },
    [u]
  );
  return v(() => (document.addEventListener(C, s), () => {
    document.removeEventListener(C, s);
  }), [s]), v(() => {
    t.setApiRoot(o), t.setClientId(e), t.setInitialValues(r), t.setCreditParamsFormatter(n);
  }, [t, o, e, r, n]), /* @__PURE__ */ L(b.Provider, { value: i, children: c });
}, T = j(k);
export {
  T as AppProvider
};
